import { makeStyles } from "tss-react/mui";
import { LinkColor, LinkSize } from "./Link.types.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const sizeScheme = (tokens, px)=>({
        [LinkSize.large]: {
            underlineOffset: `${px(5)}px`,
            icon: {
                fontSize: tokens.typography.variant.h5.fontSize,
                height: px(24),
                width: px(24),
                marginLeft: px(6),
                marginRight: px(6)
            }
        },
        [LinkSize.medium]: {
            underlineOffset: `${px(5)}px`,
            icon: {
                fontSize: tokens.typography.variant.body2.fontSize,
                height: px(16),
                width: px(16),
                marginLeft: tokens.spacing['4'],
                marginRight: tokens.spacing['4']
            }
        },
        [LinkSize.small]: {
            underlineOffset: `${px(3)}px`,
            icon: {
                fontSize: tokens.typography.variant.body2.fontSize,
                height: px(16),
                width: px(16),
                marginLeft: tokens.spacing['4'],
                marginRight: tokens.spacing['4']
            }
        },
        [LinkSize.extraSmall]: {
            underlineOffset: `${px(2)}px`,
            icon: {
                fontSize: tokens.typography.variant.caption.fontSize,
                height: px(12),
                width: px(12),
                marginLeft: tokens.spacing['4'],
                marginRight: tokens.spacing['4']
            }
        }
    });
const colorScheme = {
    [LinkColor.primary]: {
        color: (p)=>p.primary.main,
        hoveredColor: (p)=>p.primary.dark
    },
    [LinkColor.secondary]: {
        color: (p)=>p.text.secondary,
        hoveredColor: (p)=>p.text.primary
    },
    [LinkColor.tertiary]: {
        color: (p)=>p.text.tertiary,
        hoveredColor: (p)=>p.text.primary
    },
    [LinkColor.success]: {
        color: (p)=>p.success.main,
        hoveredColor: (p)=>p.success.dark
    },
    [LinkColor.error]: {
        color: (p)=>p.error.main,
        hoveredColor: (p)=>p.error.dark
    },
    [LinkColor.simple]: {
        color: (p)=>p.primary.main,
        hoveredColor: (p)=>p.primary.dark
    }
};
const useStyles = makeStyles()(({ palette, tokens, px }, { size, color, disabled, stroke, iconAlign, backLink, display })=>({
        link: _object_spread({
            textDecoration: true !== stroke || disabled ? 'none' : 'underline',
            textUnderlineOffset: true !== stroke || disabled ? 'auto' : sizeScheme(tokens, px)[size].underlineOffset,
            color: disabled ? tokens.colors.text.light.tertirary : colorScheme[color].color(palette),
            cursor: disabled ? 'default' : 'pointer'
        }, backLink && {
            display: 'flex',
            width: 'fit-content'
        }, !disabled && {
            '&:hover': {
                textDecoration: false !== stroke ? 'underline' : 'none',
                textUnderlineOffset: false !== stroke ? sizeScheme(tokens, px)[size].underlineOffset : 'auto',
                color: colorScheme[color].hoveredColor(palette)
            }
        }, display && {
            display
        }),
        disabledLink: {
            pointerEvents: 'none',
            cursor: 'default',
            textDecoration: 'none'
        },
        linkSimple: {
            textDecoration: 'none'
        },
        linkLikeButton: {
            background: 'none',
            border: 'none',
            outline: 'none',
            padding: 0,
            cursor: 'pointer',
            '&:hover': {
                background: 'inherit'
            }
        },
        icon: {
            height: sizeScheme(tokens, px)[size].icon.height,
            width: sizeScheme(tokens, px)[size].icon.width,
            display: 'flex',
            alignSelf: iconAlign || ('extraSmall' === size ? 'flex-start' : 'center'),
            '& .MuiSvgIcon-root': {
                fontSize: sizeScheme(tokens, px)[size].icon.fontSize,
                margin: 0,
                color: 'inherit'
            }
        },
        startIcon: {
            marginRight: sizeScheme(tokens, px)[size].icon.marginRight
        },
        endIcon: {
            marginLeft: sizeScheme(tokens, px)[size].icon.marginLeft
        }
    }));
export { useStyles };
